<template>
    <div id="receipt_item_view" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptInvoiceHeader">Payment Invoice View</span>
                    <div class="btn-groups text-right">
                        <button type="button" v-if="canAddCrm" class="btn btn-secondary" v-on:click="crmSection()" >
                            <i class="fp-agreement"> </i> {{crmBtnTitle}}
                        </button>
                        <template v-if="!isCrmSection">
                        <button type="submit" class="btn btn-primary" v-on:click.prevent="updateItem" >
                            <i class="fp-edit-icon"> </i> Edit
                        </button>
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackReceiptList" >
                            <i class="fp-back"> </i> Back
                        </button>
                        </template>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content receipt-item-view">
                        <template v-if="!isCrmSection">
                        <section class="internal-container border-top-table-fl">
                            <form class="form-horizontal basic-form-container metric-form" id="ReceiptInvoiceMapperForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="receipt">Receipt/Payment:</label>
                                        <span class="label">{{receiptPayment.text}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="receipt_number">Payment Number: </label>
                                        <span class="label">{{payment_number}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="payment_date">Payment Date:  </label>
                                        <span class="label">{{payment_date}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="deposit_date">Bank Code: </label>
                                        <span class="label">{{bank_code}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="deposit_date">Payment Type: </label>
                                        <span class="label">{{payment_type}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="payment_currency_code">Payment CC Code: </label>
                                        <span class="label">{{payment_currency_code}}</span>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-4 offset-md-8">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td class="bg-gray require valign-middle"> PMT Amount: </td>
                                                    <td class="text-right"> ${{payment_amount.toFixed(2)}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Amt Applied: </td>
                                                    <td class="text-right"> ${{amount_applied.toFixed(2)}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Difference: </td>
                                                    <td class="text-right"> ${{difference.toFixed(2)}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="purchase-order-create-main table-responsive-sm" v-if="rows && rows.length > 0">
                                    <!--purchase table-->
                                    <div v-if="idArr && idArr.length > 0" class="selection-info-row">
                                        <a href="javascript:void(0)" v-on:click.prevent="cancelReceiptPayment()" class="color-blue underline">Cancel</a>
                                    </div>
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width:80px;">Customer</th>
                                                <th scope="col" class="require">Invoice Number</th>
                                                <th scope="col" class="require">Original Amount</th>
                                                <th scope="col" class="require">Open Amount</th>
                                                <th scope="col" class="require">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    {{row.customer_number}}
                                                </td>
                                                <td>
                                                    {{row.invoice_number}}
                                                </td>
                                                <td v-if="row.invoice_amount">
                                                    ${{row.invoice_amount.toFixed(2)}}
                                                </td>
                                                <td v-if="row.current_open_inv_amount">
                                                    ${{row.current_open_inv_amount.toFixed(2)}}
                                                </td>
                                                <td>
                                                    <span v-if="row.mapper_id > 0">
                                                        Applied
                                                    </span>
                                                    <span v-else>
                                                        Un applied
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="accrows && accrows.length > 0" class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" style="width:400px;">Customer</th>
                                                <th scope="col">Description</th>
                                                <th scope="col" class="require">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(acrow, acindex) in accrows" :key="acindex">
                                                <td>
                                                    {{acrow.acc_customer_id}}
                                                </td>
                                                <td>
                                                    {{acrow.description}}
                                                </td>
                                                <td v-if="acrow.amount">
                                                    {{acrow.amount.toFixed(2)}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="cashrows && cashrows.length > 0" class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:400px;">Account</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Tax</th>
                                                <th scope="col" class="require">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(crow, cindex) in cashrows" :key="cindex">

                                                <td>
                                                    {{crow.gl_account_id.text}}
                                                </td>
                                                <td>
                                                    {{crow.description}}
                                                </td>
                                                <td>
                                                    {{crow.tax}}
                                                </td>
                                                <td v-if="crow.amount != ''">
                                                    {{crow.amount.toFixed(2)}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="creditrows && creditrows.length > 0" class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:400px;">GL Account</th>
                                                <th scope="col">Customer</th>
                                                <th scope="col">Unit</th>
                                                <th scope="col">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(drow, dindex) in creditrows" :key="dindex">

                                                <td>
                                                    {{drow.gl_account_id}}
                                                </td>
                                                <td>
                                                    {{drow.customer}}
                                                </td>
                                                <td>
                                                    {{drow.vehicle_id}}
                                                </td>
                                                <td>
                                                    {{drow.amount.toFixed(2)}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </section>
                        <!-- Journals -->
                        <section class="internal-container border-top-table-fl mt-4" v-if="glArr.length > 0">
                            <div class="journal-title">
                                <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
                            </div>
                            <div :id="'demo'" class="accordian-body collapse show">
                                <div class="table-reponsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1 purchase-order-item-table">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Account</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                                <th class="text-right">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="glArr != undefined && glArr.length > 0">
                                            <template v-for="(journalItem , journalKey) in glArr">
                                                <tr :key="'journal'+journalKey">
                                                    <template v-if="journalItem.account_description == 'Total'">
                                                        <td class="text-right">{{journalItem.account_description}}</td>
                                                    </template>
                                                    <template v-else>
                                                        <td>{{journalItem.account_description}}</td>
                                                    </template>
                                                    <td class="text-right">{{journalItem.debit}}</td>
                                                    <td class="text-right">{{journalItem.credit}}</td>
                                                    <td class="text-right">{{journalItem.journal_amount}}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4"><h5>No GL Found</h5></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    </section>
                        </template>
                        <template v-else>
                            <!-- Payment Receipt Crm -->
                            <div id="receipt-item-crm-list" class="admin-page-content receipt-item-view list-view">
                                <template v-if="crmAdd">
                                    <crm-create :fromModule="receiptItemObj"></crm-create>
                                </template>
                                <template v-else>
                                    <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                                    <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                        <div class="bg-white data-table p-0">
                                            <receipt-item-crm-list v-if="enableReceiptCrm" :moduleVal="'payment receipt'" :moduleId="receiptItemId"></receipt-item-crm-list>
                                        </div>
                                    </section>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'

import CrmCreate from "@/components/CrmCreate.vue";
Vue.component("crm-create", CrmCreate);

export default {
  name: "ReceiptItemView",
  components: {
        receiptItemCrmList: () => import('@/components/CrmList.vue')
    },
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "View Receipt Item | " +process.env.COPYRIGHT_NAME : "View Receipt Item | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    payment_number:'',
    payment_date:'',
    bank_code:'',
    bankArr:[],
    bank_currency_code:'USD',
    payment_currency_code:'USD',
    rows:[],
    bank_reference:'',
    bank_error_msg:'',

    difference:0.00,
    amount_applied:0.00,
    payment_amount:0.00,
    dist_company:'001',
    isRelease:false,
    receiptPaymentArr:[],
    receiptPayment:'',
    invoiceArr:[],
    invoice_id:'',
    payment_type:'',
    customer_id:0,
    customerArr:[],
    specificInvoice:false,
    gl_account_id:'',
    accountsArr:[],
    acc_amount:0.00,
    discount_amount:0.00,
    open_amount:0.00,
    application_amount:0.00,
    discount_available:0.00,
    idArr:[],
    spc_invoice_id:0,
    accrows:[],
    cashrows:[],
    glArr:[],
    receiptItemId:0,
    enableReceiptCrm:false,
    receiptItemObj:{},
    isCrmSection:false,
    canAddCrm:false,
    crmAdd:false,
    crmBtnTitle:"CRM",
    creditrows:[],
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_payment_receipt') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'add_crm') {
                        self.canAddCrm = true;
                    }
                }
            }
        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.receiptItemId = segments[3];
                //set value in receipt item object for crm
                self.receiptItemObj.module = "payment receipt";
                self.receiptItemObj.receipt_item_id = segments[3];
                self.receiptItemObj.flag = "add";
                self.receiptItemObj.crm_id = "";
                self.getReceiptPayment(segments[3],'load');
            }

        }, 100);

        // self.fetchBanks();
  },
  methods: {
      onSearchReceiptPayment(search, loading) {
        var self = this;
        // alert(search.length);
        if (search.length > 0) {
            // loading(true);
            self.getReceiptPayment(search,'search');
        }

    },
    onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
    onSearchCustomer(search, loading) {
        var self = this;

        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    spInvoice:function(id){
        var self = this;

        self.spc_invoice_id = id;
        // self.application_amount = self.difference;
        self.open_amount = self.difference;
        self.specificInvoice = true;
    },


    BackReceiptList() {
      var self = this;
      if (self.$route.params.id != undefined && self.$route.params.id > 0){
        self.$router.push("/receipt-item/list");
      }else{
        self.$router.push("/payment-receipt/list");
      }

    },
    updateItem: function(){
        var self = this;

        self.$router.push("/receipt-invoice/map/"+self.$route.params.id);
    },

    getReceiptPayment: function(search,flag){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/receipt_payment",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                search:search,
                flag:flag
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    if (flag == 'load'){
                        self.receiptPayment = data.content[0];

                        self.loadReceiptItem(self.receiptPayment.value);
                    }else{

                        self.receiptPaymentArr = data.content;

                    }
                    // if (data.bank && self.$route.params.id == undefined){
                    //     self.bank_code = data.bank;
                    // }
                } else{

                    self.receiptPaymentArr = [];
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },

    loadReceiptItem(id) {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/one-receipt-item/" + id,
            type: "GET",
            data:{
                from:'view'
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.receiptItemObj.customer_id = data.content.customer_id;
                    self.payment_number = data.content.payment_number;
                    self.payment_date = data.content.payment_date;
                    self.bank_code = data.content.bank_code;
                    self.payment_currency_code = data.content.payment_currency_code;
                    self.payment_type =  data.content.type;
                    self.payment_amount = data.content.payment_amount;
                    self.difference = data.content.difference;
                    self.amount_applied = data.content.applied_amount;

                    if (segments[3] && data.content.invoices){
                        self.invoice_id = data.content.invoices;
                        self.getInvoices();
                    }

                    if (segments[3] && data.content.invoices.customer){
                        var cust = data.content.invoices.customer;

                         self.accrows.push({
                            mapper_id: cust.id,
                            acc_customer_id: cust.customer,
                            customer_error_msg: "",
                            description: cust.description,
                            amount: cust.amount,
                            amount_error_msg:'',
                        });
                        self.custDisabled = true;
                        self.onAccount = true;
                        var amount = 0;
                    }

                    if (segments[3] && data.content.invoices.gl){
                        var gl = data.content.invoices.gl;
                        if (gl.length > 0){
                            self.cashrows = [];
                            self.onCash = true;
                            for (var i = 0; i < gl.length; i++){
                                self.cashrows.push({
                                    mapper_id: gl[i].id,
                                    gl_account_id: {text:gl[i].gl_account,value:gl[i].gl_account_id},
                                    account_error_msg: "",
                                    description: gl[i].description,
                                    amount: gl[i].amount,
                                    amount_error_msg:'',
                                    tax:gl[i].tax
                                });
                            }
                        }
                        self.glDisabled = true;
                    }
                    if (segments[3] && data.content.invoices.security){
                        var cust = data.content.invoices.security;

                         self.creditrows.push({
                            mapper_id: cust.id,
                            gl_account_id: cust.gl,
                            customer: cust.customer,
                            customer_error_msg: "",
                            vehicle_id: cust.vehicle,
                            amount: cust.amount,
                            amount_error_msg:'',
                        });
                        // self.custDisabled = true;
                        // self.onAccount = true;
                        var amount = 0;
                    }
                    if (data.content.gl != undefined) {
                        self.glArr = data.content.gl;
                    }else{
                        self.glArr = [];
                    }

                    self.calculateAmount();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'one-vendor-invoice-item');
            }
        });
    },
    getInvoices: function(){
        var self = this;

        var invArr = [];
        if(self.invoice_id != '' && self.invoice_id.length > 0){
            for(var i = 0; i < self.invoice_id.length; i++){
                invArr.push(self.invoice_id[i].value);
            }
        }

        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/get-receipt-invoices",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                id:invArr
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                   self.rows = data.content;
                    var amount = 0;
                    if(self.rows && self.rows.length > 0){
                        for(var i = 0; i < self.rows.length; i++){
                            if (self.rows[i].application_amount){

                                amount += self.rows[i].application_amount;

                            }
                        }

                        self.applied_amount = amount;
                        self.difference = self.payment_amount - self.applied_amount;
                    }

                //    self.calculateAmount();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-items');
            }
        });
    },
    calculateAmount: function(){
        var self = this;
        self.difference = self.payment_amount - self.amount_applied;
    },
    crmSection() {
        var self = this;
        if (!self.isCrmSection) {
            self.isCrmSection = true;
            self.enableReceiptCrm = true;
            self.crmBtnTitle = "Detail";
        }else{
            self.isCrmSection = false;
            self.enableReceiptCrm = false;
            self.crmAdd = false;
            self.crmBtnTitle = "CRM";
        }
    },
    addCrm() {
        var self = this;
        self.crmAdd = true;
        self.receiptItemObj.crm_id = "";
        self.receiptItemObj.flag = "add";
    },
    cancelCrmFromView() {
        var self = this;
        self.crmAdd = false;
    },
    editCrmFromView(crmId){
        var self = this;
        self.crmAdd = true;
        self.receiptItemObj.crm_id = crmId;
        self.receiptItemObj.flag = "update";
    }
  }
};
</script>
<style scoped>
.right-adjust{
    width: 50%!important;
    float: right;
    height: 38px;
    padding-right: 8px;
    border-bottom: 1px solid !important;
    border-bottom-color: #8080802e !important;
}
.overClass{
    overflow: visible !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ReceiptItemView.vue